import { render } from "./linkMenu.vue?vue&type=template&id=2a2b34e1&scoped=true"
import script from "./linkMenu.vue?vue&type=script&lang=js"
export * from "./linkMenu.vue?vue&type=script&lang=js"

import "./linkMenu.vue?vue&type=style&index=0&id=2a2b34e1&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2b34e1"]])

export default __exports__